export function unsafeFilter ($sce){
    'ngInject';
    return ( string ) => $sce.trustAsHtml(string);
}


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/unsafe/unsafe.filter.js
 **/